import { TableBody, TableCell, TableRow } from "@mui/material"
import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface BodyProps {
    children: ReactNode,
    className?: string
}

export default function Body({ children, className }: BodyProps) {
    return (
        <TableBody className={twMerge("", className)}>
            {children}
        </TableBody>)
}